export const OTCookieGroups = {
  PerformanceCookies: 2,
  FunctionalCookies: 3,
  AdvertisingCookies: 4,
};
